import AppModalContainer from '@nxsys/components/AppModalContainer';
import RPNListing from '../../rpn/listing';

type Props = {
  isOpen: boolean;
  toggle: () => void;
  cbAfterAction: () => void;
};

const RPNUpdateModal: React.FC<Props> = ({ isOpen, toggle, cbAfterAction }) => {
  return (
    <AppModalContainer
      title="RPN Update"
      isOpen={isOpen}
      toggle={toggle}
      className="max-sm:w-[100vw"
      width={1250}
      minHeight="0"
      noPaddingBody
      hiddenFooter
    >
      <RPNListing cbAfterAction={cbAfterAction} isDashboard />
    </AppModalContainer>
  );
};

export default RPNUpdateModal;
